export default __webpack_public_path__ + "static/media/Chat-Web-App.09e8e388.png";